import { Box, Typography } from '@mui/material'
import { ReactElement } from 'react'

const Empty = (): ReactElement => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
            }}
        >
            <Typography
                variant="h6"
                component="div"
                sx={{ flexGrow: 1, textAlign: 'center' }}
            >
                {/* Welcome to UBQ */}
            </Typography>
        </Box>
    )
}

export default Empty
